import { connect } from 'react-redux';
import { bindActionCreators } from 'redux'
import { withRouter } from 'react-router';
import { reduxForm } from 'redux-form';
import idx from 'idx';
import PAPBrief from 'pap/components/brief';
import { fetchCategoriesIfNeeded } from 'common/ducks/categories';
import { fetchPricing } from 'pap/ducks/pricing';
import { fetchProjectIfNeeded } from 'project/ducks/project';
import { updateProjectRequest, updateAttachments, fetchAttachments } from 'pap/ducks/project';
import {
  displayFullScreen, hideFullScreen, toggleAgencyQuestion, AGENCY_STEP
} from 'pap/ducks/workflow';
import { setBannerError } from 'error';
import {
  get1to1CreativeFromProject, getSubCategoryFromProject, getVisibleBriefQuestions
} from 'pap/utils';
import { setAgencySegment } from 'common/ducks/user';

export function mapStateToProps(state, { params }) {
  const { showingAgencyQuestion } = state.pap.workflow;
  const user = state.user.profile_data;
  const projectData = state.pap.project.projectData
  const attachments = state.pap.project.attachments
  const packages = state.pap.pricing.packages || []
  const pack = packages.find((p) => p.id == (projectData || {}).original_package)
  const subCategory = getSubCategoryFromProject(projectData, state.categories)
  let briefQuestions = getVisibleBriefQuestions(projectData, true);
  /* insert agency question if not already answered */
  if (showingAgencyQuestion) {
    briefQuestions.splice(2, 0, AGENCY_STEP);
  }

  return {
    packages: packages,
    packageName: pack? pack.name : '',
    workflow: state.pap.workflow,
    projectID: params.projectID,
    stepName: params.stepName,
    initialValues: {file_upload: attachments, ...(projectData? projectData.brief_answers:{})},
    projectData: projectData,
    attachments: attachments,
    awardValue1to1: projectData? projectData.one_to_one_negotiation_value : undefined,
    creative1to1: get1to1CreativeFromProject(projectData),
    subCategorySlug: idx(subCategory, _ => _.slug),
    user,
    subCategory,
    briefQuestions
  };
}

export function mapDispatchToProps(dispatch) {
  return bindActionCreators({
    displayFullScreen,
    hideFullScreen,
    fetchCategoriesIfNeeded,
    fetchProjectIfNeeded,
    fetchPricing,
    fetchAttachments,
    updateProjectRequest,
    updateAttachments,
    setBannerError,
    toggleAgencyQuestion,
    setAgencySegment,
    dispatch,
  }, dispatch);
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(
  reduxForm({
    form: 'pap_brief',
    destroyOnUnmount: false,
    forceUnregisterOnUnmount: false,
    /* allow the form the reinitialize with new "pristine" values every time
       the initialValues prop changes, e.g. initial values may be loaded after the form
       is initialized */
    enableReinitialize: true
  })(PAPBrief)
), { withRef: true });



// WEBPACK FOOTER //
// ./pap/containers/brief.jsx